<template>
    <div class="filter-type-selector mr-2">
        <AonDropdown
            :items="options"
            :init-selection="defaultFilter"
            :data-cy="`filter.type-selector`"
            @select-option="changeType"
        />
    </div>
</template>

<script>
import AonDropdown from '@moatmetrics/armory/src/components/base/forms/AonDropdown.vue';

export default {
    name: 'FilterTypeSelector',
    components: {
        AonDropdown,
    },
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        defaultFilter: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isOpen: false,
            curType: null,
        };
    },
    watch: {
        defaultFilter() {
            if (this.defaultFilter) {
                this.curType = this.defaultFilter.itemText;
            } else {
                this.curType = this.options[0].itemText;
            }
        },
    },
    mounted() {},
    methods: {
        open() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.$emit('open');
            }
        },
        // val: Object {itemText: String, itemValue: String}
        changeType(val) {
            this.close();
            this.curType = val.itemText;
            this.$emit('input', val);
        },
        close() {
            this.isOpen = false;
        },
    },
};
</script>

<style lang="scss">
.filter-type-selector {
    width: 40%;
}

// .filter-selection-container {
//     position: absolute;
//     display: block;
//     top: 32px;
//     left: 0px;
//     width: 200px;
//     z-index: 999;
//     box-shadow: 1px 2px 2px 3px #ccc;
//     font-size: 0.9em;

//     &:last-of-type {
//         left: auto;
//         right: 0px;
//     }

//     &.arrow-left {
//         position: absolute;
//         top: 10px;
//         left: -16px;
//     }
// }

// .filter-type-text {
//     font-size: 10px;
//     color: $grey04;
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     cursor: pointer;

//     p {
//         margin: 0;
//     }
// }

// .filter-selection-header {
//     padding: 0.5rem 1em;
//     color: inherit;
//     background-color: #f7f7f7;
//     border-bottom: 1px solid #ebebeb;
//     border-top-left-radius: calc(0.3rem - 1px);
//     border-top-right-radius: calc(0.3rem - 1px);
//     display: flex;
//     flex-direction: row;
//     justify-content: space-between;
// }

// .filter-selection-body {
//     padding: 0.5em 1em 1em 1em;
//     background-color: #fff;
//     border-bottom-left-radius: calc(0.3rem - 1px);
//     border-bottom-right-radius: calc(0.3rem - 1px);
//     display: flex;
//     flex-direction: row;
//     justify-content: space-between;
//     align-items: center;

//     .aon-dropdown {
//         p {
//             text-align: left;
//         }

//         .items {
//             min-width: 170px;
//             ul li p {
//                 text-align: left;
//             }
//         }
//     }
// }
// .icon {
//     width: 15px;
//     height: 15px;
//     cursor: pointer;
// }
// }
</style>
